import { textItems } from './shared';

export const h3 = {
  title: 'H3',
  ...textItems,
  styles: {
    ...textItems.styles,
    fontSize: '20px',
  },
};
